// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3-z-w","actionsCol":"EnrolledClinics_actionsCol__2Y-5i"};